import { type Language, LanguageContext } from "@digipost/translate";
import { FC, ReactNode } from "react";

type Props = {
  children: ReactNode;
};

function parseLanguage(languageValue: string | undefined): Language {
  switch (languageValue) {
    case "nn":
    case "en":
      return languageValue;
    default:
      return "nb";
  }
}

export const LanguageProvider: FC<Props> = ({ children }) => {
  const pathLanguage = location.pathname.split("/")[2];

  const setLanguage = (newLanguage: Language) => {
    window.location.href = location.pathname.replace(
      "/innlogging" +
        (pathLanguage === parseLanguage(pathLanguage)
          ? "/" + pathLanguage
          : ""),
      "/innlogging/" + newLanguage,
    );
  };

  return (
    <LanguageContext.Provider
      value={{
        language: parseLanguage(pathLanguage),
        setLanguage,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};
